import { ActionTree } from 'vuex';
import { CustomerDashboardState } from '../state';
import { AssistantState } from './state';

const actions: ActionTree<AssistantState, CustomerDashboardState> = {
  activatePrepareDocumentAssistant({ commit }) {
    commit('setPrepareDocumentAssistantActive', true);
  },
  deactivatePrepareDocumentAssistant({ commit }) {
    commit('setPrepareDocumentAssistantActive', false);
  },
  activateBookkeepingAssistant({ commit }) {
    commit('setBookkeepingAssistantActive', true);
  },
  deactivateBookkeepingAssistant({ commit }) {
    commit('setBookkeepingAssistantActive', false);
  }
};

export default actions;
